import {
  actionTypes,
  mailRequestSuccess,
  mailRequestFailure,
  deleteTemplateMailSuccess,
  deleteTemplateMailFailure,
  createTemplateMailSuccess,
  createTemplateMailFailure,
  modifyTemplateMailSuccess,
  modifyTemplateMailFailure,
} from "./actions";

import {
  fetchCreateTemplate,
  fetchDeleteTemplate,
  fetchTemplates,
  fetchUpdateTemplate,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchMailRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MAIL_REQUEST),
    mergeMap(() =>
      fetchTemplates().pipe(
        map((response: any) => mailRequestSuccess(response)),
        catchError((error: any) => of(mailRequestFailure(error)))
      )
    )
  );

const fetchCreateMailRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_TEMPLATE_MAIL),
    mergeMap((action: any) =>
      fetchCreateTemplate(action.payload).pipe(
        map((response: any) => createTemplateMailSuccess(response)),
        catchError((error: any) => of(createTemplateMailFailure(error)))
      )
    )
  );

const fetchModifyMailRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.MODIFY_TEMPLATE_MAIL),
    mergeMap((action: any) =>
      fetchUpdateTemplate(action.payload).pipe(
        map((response: any) => modifyTemplateMailSuccess(response)),
        catchError((error: any) => of(modifyTemplateMailFailure(error)))
      )
    )
  );

const fetchDeleteTemplateMailEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_TEMPLATE_MAIL),
    mergeMap((action: any) =>
      fetchDeleteTemplate(action.id).pipe(
        map((response: any) => deleteTemplateMailSuccess(response)),
        catchError((error: any) => of(deleteTemplateMailFailure(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  fetchMailRequestEpic,
  fetchCreateMailRequestEpic,
  fetchModifyMailRequestEpic,
  fetchDeleteTemplateMailEpic,
];
